export default __webpack_public_path__ + "static/media/UY.e7f228ee.svg";